import { Stack } from 'components/Stack'
import { styled } from 'stitches.config'

export const ProductCounterRoot = styled(Stack, {
  variants: {
    direction: {
      row: {
        flexDirection: 'row',
        gap: '$3',
      },
      column: {
        flexDirection: 'column',
        gap: '$1',
      },
    },
  },
})

export const Counter = styled(Stack, {
  width: '$7',
  height: '$5',
  border: 'none',
  backgroundColor: '$tertiary-100',
  borderRadius: '$2',

  '& input': {
    display: 'block',
    height: '$5',
    border: 'none',
    maxWidth: '$7',
    backgroundColor: '$tertiary-100',
    textAlign: 'center',
    borderRadius: '$2',

    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },

    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },

    color: '$tertiary-900',
    fontWeight: '$bold',
    fontSize: '$body',
  },
})
